module.exports = __webpack_public_path__ + "img/salam-2.f06e3b72.png";